import { EFinancingCompany } from '@if/core/types'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { usePreferences } from '@src/providers/PreferencesProvider'
import { useOptionalUser } from '@src/providers/UserProvider'
import { useLocation, useNavigate } from 'react-router-dom'

const CompanySelector = () => {
  const user = useOptionalUser()
  const { selectedCompany, setSelectedCompany } = usePreferences()
  const availableCompanies = user?.companyIds ?? []
  const navigate = useNavigate()
  const location = useLocation()
  const updateSearch = new URLSearchParams(location.search)

  const showCompanySelector =
    availableCompanies.includes(EFinancingCompany.IFinance) && availableCompanies.includes(EFinancingCompany.Iceberg)

  const handleChange = (event: SelectChangeEvent<EFinancingCompany>) => {
    const company = event.target.value as EFinancingCompany
    setSelectedCompany(company)
    updateSearch.set('financingCompanyId', company)
    const newUrl = `${location.pathname}?${updateSearch.toString()}`
    navigate(newUrl, { replace: true })
  }

  if (!showCompanySelector || availableCompanies.length === 0) {
    return null
  }

  return (
    <Select
      sx={{
        color: '#ffffff',
        border: '1px solid #ffffff',
        '& .MuiSvgIcon-root': {
          color: '#ffffff',
        },
      }}
      value={selectedCompany ?? ''}
      onChange={handleChange}
    >
      {availableCompanies.map((company) => (
        <MenuItem key={company} value={company}>
          {company}
        </MenuItem>
      ))}
    </Select>
  )
}

export default CompanySelector
